import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { environment } from '@env/environment';
import { Observable, Subject } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class NotificationsService {
  private _httpClient = inject(HttpClient);
  private readonly endPoint = environment.API_ENDPOINT + `notification/`;
  private readonly activityNotificationEndPoint = environment.API_ENDPOINT + `notifications`;
  private readonly activityNavigationTargetStorageKey = 'rtis_activity_notification_target';
  overlaySubject = new Subject();
  activityNavigationTargetSubject = new Subject<any>();
  getAll(options?: {
    brand?: string;
    factory?: string;
    consultant?: string;
    admin: boolean;
    take?: number;
  }) {
    return this._httpClient.get(
      `${this.endPoint}?brand=${options.brand || ''}&factory=${options.factory || ''}&consultant=${
        options.consultant || ''
      }&admin=${options.admin || ''}&take=${options.take || 0}`
    );
  }
  getAllForAdmin(): Observable<any> {
    return this._httpClient.get(`${this.endPoint}?take=0`);
  }
  getActivityNotifications(options: {
    take?: number;
    page?: number;
    notificationViewer: string;
    projectIds?: string[];
    factoryId?: string;
    consultantId?: string;
  }): Observable<any> {
    let params = new HttpParams()
      .set('take', String(options.take || 50))
      .set('page', String(options.page || 1))
      .set('notificationViewer', options.notificationViewer);
    if (options.factoryId) {
      params = params.set('factoryId', options.factoryId);
    }
    if (options.consultantId) {
      params = params.set('consultantId', options.consultantId);
    }
    (options.projectIds || []).forEach(projectId => {
      params = params.append('projectIds', projectId);
    });
    return this._httpClient.get(this.activityNotificationEndPoint, { params });
  }
  updateActivityNotification(
    activityLogId: string,
    payload: { seen: boolean; archived: boolean }
  ): Observable<any> {
    return this.updateActivityNotifications({
      activityLogIds: [activityLogId],
      ...payload
    });
  }
  updateActivityNotifications(payload: {
    activityLogIds: string[];
    seen: boolean;
    archived: boolean;
  }): Observable<any> {
    return this._httpClient.patch(this.activityNotificationEndPoint, payload);
  }
  updateNotification(id: string, notification: any) {
    return this._httpClient.patch(`${this.endPoint}${id}`, notification);
  }
  delete(id: string): Observable<any> {
    return this._httpClient.delete(`${this.endPoint}${id}`);
  }
  markAllAsRead(payload: any): Observable<any> {
    return this._httpClient.post(`${this.endPoint}read-all`, payload);
  }
  create(payload: any): Observable<any> {
    return this._httpClient.post(`${this.endPoint}custom`, payload);
  }
  setActivityNavigationTarget(target: any): void {
    sessionStorage.setItem(this.activityNavigationTargetStorageKey, JSON.stringify(target));
    this.activityNavigationTargetSubject.next(target);
  }
  getActivityNavigationTarget(): any {
    const target = sessionStorage.getItem(this.activityNavigationTargetStorageKey);
    return target ? JSON.parse(target) : null;
  }
  clearActivityNavigationTarget(): void {
    sessionStorage.removeItem(this.activityNavigationTargetStorageKey);
  }
  getTotalNotification(options?: {
    brand?: string;
    factory?: string;
    consultant?: string;
    admin: boolean;
    take?: number;
  }): Observable<any> {
    return this._httpClient.get(
      `${this.endPoint}total-notification?brand=${options.brand || ''}&factory=${
        options.factory || ''
      }&consultant=${options.consultant || ''}&admin=${options.admin || ''}`
    );
  }
}
